import DefaultFooter from '@/components/App/Footer/DefaultFooter';
import UnAuthorizedHeader from '@/components/App/Header/UnAuthorizedHeader';
import AgentRegisterPage from '@/pages/Auth/AgentRegister.page';
import ForgotPasswordPage from '@/pages/Auth/ForgotPassword.page';
import LoginPage from '@/pages/Auth/Login.page';
import ResetPasswordPage from '@/pages/Auth/ResetPassword.page';
import { AppUrls } from '@/urls';
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

export default function UnAuthorizedLayout() {
  return (
    <>
      <div className="header-margin"></div>
      <UnAuthorizedHeader />
      <Switch>
        <Route exact path={AppUrls.Login} component={LoginPage} />
        <Route exact path={AppUrls.Register} component={AgentRegisterPage} />
        <Route exact path={AppUrls.ForgotPassword} component={ForgotPasswordPage} />
        <Route exact path={`${AppUrls.ResetPassword}/:token`} component={ResetPasswordPage} />

        <Redirect from="*" to={AppUrls.Login} />
      </Switch>
      <DefaultFooter />
    </>
  );
}
